import { ICustomer } from '../../@types';
import * as constants from './constants';
import { CustomerAction } from './action';

export interface ICustomerState {
  customer: ICustomer;
}

export const initialState: ICustomerState = {
  customer: {
    companyName: '',
    companyAddressCity: '',
    companyAddressCountry: '',
    companyAddressState: '',
    companyAddressStreet: '',
    companyAddressZip: '',
    createdBy: null,
    email: '',
    id: undefined,
    notes: '',
    phone: '',
    pocFirstName: '',
    pocLastName: '',
    pocPosition: '',
    resellerId: null,
    userId: null,
    createdDate: new Date(),
    updatedDate: new Date()
  }
};

export const reducer = (
  state: ICustomerState = initialState,
  action: CustomerAction
): ICustomerState => {
  switch (action.type) {
    case constants.UPDATE_CUSTOMER:
      return {
        ...state,
        customer: {
          ...action.payload,
          createdDate: new Date(action.payload.createdDate),
          updatedDate: new Date(action.payload.updatedDate)
        }
      };
    case constants.CLEAR_CUSTOMER:
      return {
        ...state,
        customer: initialState.customer
      };
    /* istanbul ignore next */
    default:
      return {
        ...state
      };
  }
};



// WEBPACK FOOTER //
// ./src/modules/customer/reducer.ts